import { useEffect, useCallback } from "react";
import * as Notifications from "expo-notifications";
import { Platform } from "react-native";
import { showNotification, hideToast } from "../utils/toast";

export function useNotification() {
  const showCustomNotification = useCallback(
    (title: string, body: string, onPress?: () => void) => {
      showNotification(title, body, onPress);
    },
    []
  );

  const hideNotification = useCallback(() => {
    hideToast();
  }, []);

  useEffect(() => {
    const subscription = Notifications.addNotificationReceivedListener(
      (notification) => {
        showCustomNotification(
          notification.request.content.title || "New Notification",
          notification.request.content.body || "You have a new notification"
        );
      }
    );
    return () => {
      subscription.remove();
    };
  }, []);

  return {
    showCustomNotification,
    hideNotification,
  };
}

export async function registerForPushNotificationsAsync() {
  if (Platform.OS === "web") {
    return;
  }
  let token: string | undefined;
  const { status: existingStatus } = await Notifications.getPermissionsAsync();
  let finalStatus = existingStatus;
  if (existingStatus !== "granted") {
    const { status } = await Notifications.requestPermissionsAsync();
    finalStatus = status;
  }
  if (finalStatus !== "granted") {
    return;
  }
  try {
    token = (await Notifications.getExpoPushTokenAsync()).data;
  } catch (error) {
    console.warn(
      "[Push] Failed to fetch Expo push token; notifications may be unavailable.",
      error
    );
    return;
  }

  if (Platform.OS === "android") {
    Notifications.setNotificationChannelAsync("default", {
      name: "default",
      importance: Notifications.AndroidImportance.MAX,
      vibrationPattern: [0, 250, 250, 250],
      lightColor: "#FF231F7C",
    });
  }

  return token;
}
